module.exports = __webpack_public_path__ + "static/media/cuboid4x5x9.856f31aa.gltf";